import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../lib/api'

export interface SyncStatus {
  sync_type: string
  status: 'in_progress' | 'success' | 'error' | 'cancelled'
  last_sync_at: string
  completed_at?: string | null
  duration_seconds?: number | null
  items_processed?: number | null
  items_created?: number | null
  items_updated?: number | null
  items_failed?: number | null
  error_message?: string | null
}

export interface SyncTypeStatus {
  sync_type: string
  count_today: number
}

export interface LatestSync {
  last_sync_at?: string | null
  last_sync_type?: string | null
  total_syncs_today: number
  sync_types_status: SyncTypeStatus[]
}

const SYNC_STATUS_QUERY_KEY = 'sync-status'

export const useSyncStatus = (syncType?: string) => {
  return useQuery({
    queryKey: [SYNC_STATUS_QUERY_KEY, syncType],
    queryFn: async (): Promise<SyncStatus[]> => {
      const response = await apiClient.getSyncStatus(syncType)
      // API returns data directly, not wrapped in response.data
      return (response as unknown as SyncStatus[]) || []
    },
    staleTime: 60 * 1000, // 1 minute
    retry: 2,
  })
}

export const useLatestSync = () => {
  return useQuery({
    queryKey: [SYNC_STATUS_QUERY_KEY, 'latest'],
    queryFn: async (): Promise<LatestSync> => {
      const response = await apiClient.getLatestSync()
      // API returns data directly, not wrapped in response.data
      return response as unknown as LatestSync
    },
    staleTime: 30 * 1000, // 30 seconds
    retry: 2,
    refetchInterval: 60 * 1000, // Refetch every minute
  })
}